import { render, staticRenderFns } from "./VerifyMail.vue?vue&type=template&id=141321bb&"
import script from "./VerifyMail.vue?vue&type=script&lang=js&"
export * from "./VerifyMail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports